export enum GroupPerTimeType {
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
}
